'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectEditorEnhancer = require('../../../../DocEditor/objectEditorEnhancer');

var _objectEditorEnhancer2 = _interopRequireDefault(_objectEditorEnhancer);

var _AuthLine = require('./AuthLine');

var _AuthLine2 = _interopRequireDefault(_AuthLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _objectEditorEnhancer2.default)(_AuthLine2.default);


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/GroupEditor/AuthEditor/AuthBody/AuthLine/index.js
// module id = 1784
// module chunks = 0